import { a as g, u as K, s as X } from "./objectWithoutPropertiesLoose-Cg0fb85x.mjs";
import * as l from "react";
function Z(e) {
  return typeof e == "string";
}
function fe(e, r = {}, s) {
  return Z(e) ? r : g({}, r, {
    ownerState: g({}, r.ownerState, s)
  });
}
function z(e, r = []) {
  if (e === void 0)
    return {};
  const s = {};
  return Object.keys(e).filter((u) => u.match(/^on[A-Z]/) && typeof e[u] == "function" && !r.includes(u)).forEach((u) => {
    s[u] = e[u];
  }), s;
}
class R {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new R();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(r, s) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, s();
    }, r);
  }
}
let M = !0, T = !1;
const J = new R(), Q = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function Y(e) {
  const {
    type: r,
    tagName: s
  } = e;
  return !!(s === "INPUT" && Q[r] && !e.readOnly || s === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function ee(e) {
  e.metaKey || e.altKey || e.ctrlKey || (M = !0);
}
function w() {
  M = !1;
}
function te() {
  this.visibilityState === "hidden" && T && (M = !0);
}
function re(e) {
  e.addEventListener("keydown", ee, !0), e.addEventListener("mousedown", w, !0), e.addEventListener("pointerdown", w, !0), e.addEventListener("touchstart", w, !0), e.addEventListener("visibilitychange", te, !0);
}
function ne(e) {
  const {
    target: r
  } = e;
  try {
    return r.matches(":focus-visible");
  } catch {
  }
  return M || Y(r);
}
function ue() {
  const e = l.useCallback((o) => {
    o != null && re(o.ownerDocument);
  }, []), r = l.useRef(!1);
  function s() {
    return r.current ? (T = !0, J.start(100, () => {
      T = !1;
    }), r.current = !1, !0) : !1;
  }
  function u(o) {
    return ne(o) ? (r.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: r,
    onFocus: u,
    onBlur: s,
    ref: e
  };
}
function C(e) {
  var r, s, u = "";
  if (typeof e == "string" || typeof e == "number") u += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (r = 0; r < e.length; r++) e[r] && (s = C(e[r])) && (u && (u += " "), u += s);
  else for (r in e) e[r] && (u && (u += " "), u += r);
  return u;
}
function de() {
  for (var e, r, s = 0, u = ""; s < arguments.length; ) (e = arguments[s++]) && (r = C(e)) && (u && (u += " "), u += r);
  return u;
}
function be(e, r, s) {
  const u = {};
  return Object.keys(e).forEach(
    // `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (o) => {
      u[o] = e[o].reduce((f, c) => (c && (s && s[c] && f.push(s[c]), f.push(r(c))), f), []).join(" ");
    }
  ), u;
}
const D = (e) => e, se = () => {
  let e = D;
  return {
    configure(r) {
      e = r;
    },
    generate(r) {
      return e(r);
    },
    reset() {
      e = D;
    }
  };
}, ae = se(), oe = {
  active: "Mui-active",
  checked: "Mui-checked",
  completed: "Mui-completed",
  disabled: "Mui-disabled",
  error: "Mui-error",
  expanded: "Mui-expanded",
  focused: "Mui-focused",
  focusVisible: "Mui-focusVisible",
  required: "Mui-required",
  selected: "Mui-selected"
};
function ie(e, r) {
  return oe[r] || `${ae.generate(e)}-${r}`;
}
function ge(e, r) {
  const s = {};
  return r.forEach((u) => {
    s[u] = ie(e, u);
  }), s;
}
function ye(e) {
  var r;
  const {
    component: s,
    components: u = {},
    disabled: o = !1,
    href: f,
    ref: c,
    tabIndex: N = 0,
    to: k,
    type: v
  } = e, y = l.useRef(), [B, m] = l.useState(!1), {
    isFocusVisibleRef: p,
    onFocus: U,
    onBlur: I,
    ref: S
  } = ue(), [d, h] = l.useState(!1);
  o && d && h(!1), l.useEffect(() => {
    p.current = d;
  }, [d, p]);
  const x = (n) => (t) => {
    var a;
    d && t.preventDefault(), (a = n.onMouseLeave) == null || a.call(n, t);
  }, L = (n) => (t) => {
    var a;
    I(t), p.current === !1 && h(!1), (a = n.onBlur) == null || a.call(n, t);
  }, A = (n) => (t) => {
    var a;
    if (y.current || (y.current = t.currentTarget), U(t), p.current === !0) {
      var i;
      h(!0), (i = n.onFocusVisible) == null || i.call(n, t);
    }
    (a = n.onFocus) == null || a.call(n, t);
  }, O = (r = s ?? u.Root) != null ? r : "button", E = () => {
    const n = y.current;
    return O !== "button" && !((n == null ? void 0 : n.tagName) === "A" && n != null && n.href);
  }, $ = (n) => (t) => {
    var a;
    t.target === t.currentTarget && !o && m(!0), (a = n.onMouseDown) == null || a.call(n, t);
  }, _ = (n) => (t) => {
    var a;
    t.target === t.currentTarget && m(!1), (a = n.onMouseUp) == null || a.call(n, t);
  }, H = (n) => (t) => {
    var a;
    if ((a = n.onKeyDown) == null || a.call(n, t), !t.defaultPrevented && (t.target === t.currentTarget && E() && t.key === " " && t.preventDefault(), t.target === t.currentTarget && t.key === " " && !o && m(!0), t.target === t.currentTarget && E() && t.key === "Enter" && !o)) {
      var i;
      (i = n.onClick) == null || i.call(n, t), t.preventDefault();
    }
  }, P = (n) => (t) => {
    var a;
    if (t.target === t.currentTarget && m(!1), (a = n.onKeyUp) == null || a.call(n, t), t.target === t.currentTarget && E() && t.key === " " && !t.defaultPrevented) {
      var i;
      (i = n.onClick) == null || i.call(n, t);
    }
  }, G = K(S, y), q = K(c, G), [V, j] = l.useState(""), W = (n) => {
    var t;
    j((t = n == null ? void 0 : n.tagName) != null ? t : ""), X(q, n);
  }, b = {};
  return V === "BUTTON" ? (b.type = v ?? "button", b.disabled = o) : V !== "" && (!f && !k && (b.role = "button"), o && (b["aria-disabled"] = o)), {
    getRootProps: (n) => {
      const t = z(e), a = g({}, t, n), i = {
        onBlur: L(a),
        onFocus: A(a),
        onKeyDown: H(a),
        onKeyUp: P(a),
        onMouseDown: $(a),
        onMouseLeave: x(a),
        onMouseUp: _(a)
      }, F = g({}, a, i);
      return delete F.onFocusVisible, g({
        tabIndex: o ? -1 : N,
        type: v
      }, b, F, {
        ref: W
      });
    },
    focusVisible: d,
    setFocusVisible: h,
    disabled: o,
    active: B
  };
}
export {
  ie as a,
  fe as b,
  de as c,
  be as d,
  z as e,
  ge as g,
  ye as u
};
//# sourceMappingURL=useButton-BpXsRUgx.mjs.map
